export const TERMS_BASE_PATH = "/assets/assignment";

export const TERMS_DOCX = {
  terms: {
    file: "동네방네 서비스 통합 정책 가이드라인_V3.docx",
    title: "이용약관",
  },
  privacy: {
    file: "개인정보_처리방침_소비자_V3.docx",
    title: "개인정보 수집이용 동의 (소비자)",
  },
  seller: {
    file: "개인정보_처리방침_가맹점_V3.docx",
    title: "개인정보 수집이용 동의 (가맹점)",
  },
  marketing: {
    file: "동네방네_마케팅_수신 동의_소비자약관_V2.docx",
    title: "마케팅 정보 및 알림 수신 동의 (소비자)",
  },
  marketingStore: {
    file: "동네방네_마케팅_수신 동의_가맹점약관_V2.docx",
    title: "마케팅 정보 및 알림 수신 동의 (가맹점)",
  },
};

export const getTermsDocxUrl = (fileName) => {
  const encodedPath = fileName
    .split("/")
    .map((segment) => encodeURIComponent(segment))
    .join("/");
  return `${TERMS_BASE_PATH}/${encodedPath}`;
};

export const getTermsByType = (type) => TERMS_DOCX[type] ?? null;